import React, { FunctionComponent } from "react";
import { Typography, Button } from "@material-ui/core";
import "./index.scss";
import { Link } from "../../config/components";
import DynamicImage from "../dynamicImage";
import { ContentPageItemCollection } from "services/entities/content";

import ContentItem from "components/content/ContentItem";

interface BackgroundAssetPosition {
  top?: string | any;
  right?: string | any;
  bottom?: string | any;
  left?: string | any;
}

type TextMediaProps = {
  title?: string | any;
  text?: string | any;
  code?: string | any;
  backgroundAsset?: string;
  backgroundAssetPosition?: BackgroundAssetPosition;
  backgroundAssetSize?: string;
  index?: number;
  imageLeft?: boolean;
  sectionTitle?: string | any;
  highlightedText?: string | any;
  link?: Link | undefined;
  leftAligned?: boolean;
};

type DynamicImage = {
  imageSm?: URL;
  imageMd?: URL;
  imageLg?: URL;
  imageXl?: URL;
};

export const TextMedia: FunctionComponent<TextMediaProps> = ({
  title,
  text,
  code,
  backgroundAsset,
  backgroundAssetPosition = {
    top: "0px",
    bottom: "0px",
    left: "0px",
    right: "0px",
  },
  backgroundAssetSize,
  index,
  imageLeft,
  sectionTitle,
  highlightedText,
  leftAligned,
  link,
}) => {
  return (
    <div
      className={`section-mw section--text-media has-background-image ${leftAligned ? 'left-aligned' : ''}`}
      style={{
        backgroundImage: `url("${backgroundAsset}")`,
        backgroundSize: `${backgroundAssetSize}`,
        backgroundPosition: `${backgroundAssetPosition.right} ${backgroundAssetPosition.top}`,
      }}
    >
      <ContentItem code={code}>
        {(item) => {
          return (
            item && (
              <section
                className={`content-mw module-grid text-media-${index} ${
                  imageLeft ? `image-left` : ``
                } ${
                  ((item as ContentPageItemCollection).image as URL) &&
                  (
                    (item as ContentPageItemCollection).image as URL
                  ).hasOwnProperty("xl")
                    ? `has-image`
                    : `no-image`
                }`}
              >
                {sectionTitle && (
                  <Typography
                    variant="h3"
                    component="h2"
                    className="section-title"
                  >
                    {sectionTitle}
                  </Typography>
                )}

                {(item as ContentPageItemCollection).title && (
                  <Typography
                    variant="h1"
                    component="h2"
                    className="title"
                    dangerouslySetInnerHTML={{
                      __html:
                        highlightedText && highlightedText.length
                          ? `<span class="highlighted">${highlightedText}</span>  ${(
                              item as ContentPageItemCollection
                            ).title.toString()}`
                          : (
                              item as ContentPageItemCollection
                            ).title.toString(),
                    }}
                  />
                )}
                {(item as ContentPageItemCollection).text && (
                  <Typography
                    variant="body1"
                    component="div"
                    className="text"
                    dangerouslySetInnerHTML={{
                      __html: (
                        item as ContentPageItemCollection
                      ).text.toString(),
                    }}
                  />
                )}
                {((item as ContentPageItemCollection).image as URL) &&
                  (
                    (item as ContentPageItemCollection).image as URL
                  ).hasOwnProperty("xl") && (
                    <DynamicImage
                      item={(item as ContentPageItemCollection).image}
                    />
                  )}
                {((item as ContentPageItemCollection).link as Link) && (
                  <Button
                    className="link"
                    href={
                      ((item as ContentPageItemCollection).link as Link).url
                    }
                  >
                    {((item as ContentPageItemCollection).link as Link).label}
                  </Button>
                )}
              </section>
            )
          );
        }}
      </ContentItem>
    </div>
  );
};

export default TextMedia;
